Object.values = function(obj) {
  //    ^ no .prototype
  return Object.keys(obj).map(function(e) {
    return obj[e]
  })
}

//import '@babel/polyfill'
import 'core-js/modules/es6.map'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from '@/App.vue'

import router from '@/router'
import store from '@/services/store'

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@/_scss/main.scss'
// import ru from '@/services/vuetify_ru.js'
import ru from 'vuetify/es5/locale/ru'
import en from 'vuetify/es5/locale/en'
import uk from 'vuetify/es5/locale/uk'

// import VueCookie from 'vue-cookie'

import IdleVue from 'idle-vue'
//Font awesome
import 'vue-awesome/icons'
import firebaseConfig from './config/firebase'
import firebase from 'firebase'
import 'firebase'
import i18n from '@/plugins/i18n'

const eventsHub = new Vue()

const cookieCurrentLang = localStorage.currentLang
const cookieCurrentFlag = localStorage.currentFlag
let currentLocale = cookieCurrentLang === 'ua' ? 'uk' : cookieCurrentLang

if (cookieCurrentLang && cookieCurrentFlag) {
  i18n.locale = cookieCurrentLang
  let locale = { lang: cookieCurrentLang, flag: cookieCurrentFlag }
  store.dispatch('updateLang', locale)
} else {
  currentLocale = 'uk'
}

// Vue.use(IdleVue, {
//   eventEmitter: eventsHub,
//   idleTime: 60000,
// })

Vue.use(Vuetify, {
  theme: {
    primary: '#fff',
    secondary: '#b0bec5',
    accent: '#8c9eff',
    error: '#b71c1c',
  },
  lang: {
    locales: { ru, uk, en },
    current: currentLocale,
  },
})

// Vue.use(VueCookie)
// process.env.NODE_ENV === 'production'
//   ? ''
//   : 'http://mt.dieselservice.com.ua:1234/13072018'
const cookieServerAddress = localStorage.serverAddress
if (cookieServerAddress)
  store.commit('updateServerAddress', cookieServerAddress)

const cookieUseIdleVue = localStorage.useIdleVue
if (typeof cookieUseIdleVue != 'undefined' && cookieUseIdleVue != null)
  store.commit('updateUseIdleVue', cookieUseIdleVue === 'false' ? false : true)

const showFactColumns = localStorage.showFactColumns
store.commit('updateShowFactColumns', showFactColumns)

import VuePikaday from '@netcz/vue-pikaday'
import '@netcz/vue-pikaday/dist/vue-pikaday.min.css'
Vue.use(VuePikaday)

import Icon from 'vue-awesome/components/Icon'
Vue.component('icon', Icon)

import CountryFlag from 'vue-country-flag'
Vue.component('country-flag', CountryFlag)

Vue.config.productionTip = false
Vue.config.devtools = true

firebase.initializeApp(firebaseConfig)
firebase.analytics()
firebase.auth()

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App),
  // onIdle() {
  //   if (!store.state.testMode && store.state.useIdleVue) {
  //     if (window.location.pathname !== '/') {
  //       router.push({ path: '/' })
  //     }
  //   }
  // },
  onActive() {},
})
